"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLink = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../Icon/Icon");
var Link_1 = require("../Link/Link");
var Tooltip_1 = require("../Tooltip/Tooltip");
var Typography_1 = require("../Typography/Typography");
var TextLink_style_1 = __importDefault(require("./TextLink.style"));
/**
 * TextLink atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-textlink--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/TextLink Source}
 */
var TextLink = function (_a) {
    var className = _a.className, children = _a.children, url = _a.url, onClick = _a.onClick, fontVariant = _a.fontVariant, tooltip = _a.tooltip, interactiveTooltip = _a.interactiveTooltip, icon = _a.icon, block = _a.block, numberOfLines = _a.numberOfLines, bold = _a.bold, isLinkInTooltip = _a.isLinkInTooltip, breakAll = _a.breakAll;
    var classes = (0, TextLink_style_1.default)();
    if (url) {
        return ((0, jsx_runtime_1.jsx)(Link_1.Link, __assign({ className: (0, classnames_1.default)(className, classes.root, 'hoverable', block && classes.block), url: url, onNavigate: onClick, tooltip: tooltip, interactiveTooltip: interactiveTooltip }, { children: renderContent() })));
    }
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: tooltip, className: (0, classnames_1.default)(className, classes.root, 'hoverable', block && classes.block), interactive: interactiveTooltip }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ onClick: onClick }, { children: renderContent() })) })));
    function renderContent() {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ component: 'span', overflowEllipsis: true, noWrap: block, numberOfLines: numberOfLines, variant: fontVariant, color: isLinkInTooltip ? 'white' : theme_1.default.textColors.highlight, underline: isLinkInTooltip, bold: bold, hoverVariant: isLinkInTooltip ? 'opacity' : 'dark', breakAll: breakAll }, { children: children })), icon && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icon, color: isLinkInTooltip ? 'white' : theme_1.default.textColors.highlight, className: classes.icon, hoverVariant: isLinkInTooltip ? 'opacity' : 'primaryDark' }))] }));
    }
};
exports.TextLink = TextLink;
